export default {
  Validate: {
    ComfirmDeleteBalanceAccount:
      'Bạn có chắc chắn muốn xóa số dư ban đầu của tài khoản <span class="color-green">{0}</span> không?',
    ComfirmDeleteBalanceBankAccount:
      'Bạn có chắc chắn muốn xóa số dư ban đầu của tài khoản ngân hàng <span class="color-green">{0}</span> không?',
    ComfirmDeleteBalanceAccountingObjectAccount:
      'Bạn có chắc chắn muốn xóa số dư ban đầu của đối tượng <span class="color-green">{0}</span> không?',
    ComfirmDeleteBalanceInventoryBalance:
      'Bạn có chắc chắn muốn xóa số dư ban đầu của Vật tư/CCDC <span class="color-green">{0}</span> không?',
    ConfirmDeleteBalanceAccountTitle: 'Xóa số dư tài khoản',
    ChangeDataTitle: 'Cất số dư ban đầu',
    ChangeDataMessge: 'Dữ liệu đã bị thay đổi, bạn có muốn cất số dư ban đầu không?',
    DuplicateValidate: 'Không được phép nhập các dòng có thông tin chi tiết số dư giống nhau.',
    RequiredValidate: '{0} không được bỏ trống.',
    DuplicateValidateInventory: 'Không được phép nhập các dòng có Số lô/Số phiếu nhập giống nhau.',
    AmountLengthValidate: '{0} vượt quá 14 ký tự.',
    ComfirmDeleteBankBalanceAccount: 'Bạn có chắc chắn xóa số dư tài khoản <span class="color-green">{0}</span> không?',
    ComfirmDeleteBankBalanceAccountTitle: 'Xóa số dư ban đầu',
    ComfirmDeleteOPObjectTitle: 'Xóa số dư',
    ComfirmDeleteOPObject: 'Bạn có chắc chắn muốn xóa số dư của {0} <span class="color-green">{1}</span> không?',
    ComfirmDeleteOPMulti: 'Bạn có chắc chắn muốn xóa số dư của các tài khoản đã chọn không?',
    ComfirmDeleteOpeningInventoryTitle: 'Xóa số dư',
    ComfirmDeleteOpeningInventory:
      'Bạn có muốn chắc chắn xóa số dư của vật tư <span class="color-green">{0}</span> không?',
    ComfirmDeleteOpeningInventoryMulti: 'Bạn có muốn chắc chắn xóa số dư của các vật tư đã chọn không?',
    ValidateOutOfRangeAmount: 'Giá trị nhập kho không được vượt quá 14 ký tự.',
    ValidateFocusLeaveControlTitle: 'Nhập số dư ban đầu',
    ValidateFocusLeaveControl: 'Vui lòng nhấn "Lấy dữ liệu" để nhập số dư ban đầu cho {0}.',
    ConfirmDelete: 'Bạn có muốn xóa {0} <span class="color-green">{1}</span> không?',
  },
};
